import type { MarpolAnnexI } from "@features/vessel-call/vessel-call-status/PortServices/store/usePortServicesForm.store";
import { type TFunction } from "i18next";
import { z } from "zod";
import { validateMarpolAnnexI, validateRts } from "./sharedValidators";

const LANG_BASE = "vessel-call.port-services";

type SlopsData = {
  registeredAgentName?: string;
  registeredAgentContactPerson?: string;
  serviceProviderName?: string;
  rts?: string | Date | null;
  operationLocation?: string;
  intendedOperationDetails?: string;
  wasteResiduesForDischargeFacility?: MarpolAnnexI[];
};

export const validateSlopsServices = (data: SlopsData, ctx: z.RefinementCtx, t: TFunction) => {
  const requiredFields: Array<{
    key: keyof SlopsData;
    labelKey: string;
  }> = [
    { key: "registeredAgentName", labelKey: "name" },
    { key: "registeredAgentContactPerson", labelKey: "contact-person" },
    { key: "serviceProviderName", labelKey: "service-provider-name" },
    { key: "operationLocation", labelKey: "operation-location" },
    { key: "intendedOperationDetails", labelKey: "details-of-intended-operation" },
  ];

  requiredFields.forEach(({ key, labelKey }) => {
    if (!data[key]) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: t("form-validation.required", {
          label: t(`${LANG_BASE}.fields.${labelKey}`),
        }),
        path: [key],
      });
    }
  });
  validateRts(data.rts, ctx, t);
  validateMarpolAnnexI(data.wasteResiduesForDischargeFacility, ctx, t);
};
